import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Spinner, SpinnerData } from '../../../shared/components/spinner/spinner';


@Injectable({ providedIn: 'root' })
export class SpinnerService {
  constructor(private dialog: MatDialog) {}

  open(data: SpinnerData) {
    return this.dialog.open(Spinner, {
      data,
      disableClose: true,
    })
    .afterClosed();
  }
  close() {
    this.dialog.closeAll();
  }
}
